import { PetCustomReminderModel } from '@common/models/PetCustomReminders';
import { stringDateToISODate } from '@common/utils';
import { observer } from 'mobx-react'
import React from 'react'
import { Button, Table } from 'react-bootstrap';

interface IThirdPartyRemindersTableProps {
    remindersAdded: PetCustomReminderModel[];
    setActiveReminder: (value: PetCustomReminderModel) => void;
    onSelectedToRemind: () => void;
    removeReminder: (salesItemOptionId: number) => void;
}

export const ThirdPartyRemindersTable = observer(({ remindersAdded, setActiveReminder, onSelectedToRemind, removeReminder }: IThirdPartyRemindersTableProps) => {
    const onRemind = (reminder: PetCustomReminderModel) => {
        setActiveReminder(reminder);
        onSelectedToRemind();
    }

    return (
        <Table hover striped size="sm">
            <thead>
                <tr>
                    <th className="text-start" style={{ width: "40rem" }}>Description</th>
                    <th className="text-end pe-5" style={{ width: "12rem" }}>Status</th>
                    <th className="text-end pe-4" style={{ width: "14rem" }}>Actions</th>
                </tr>
            </thead>
            <tbody>
                {
                    _.isEmpty(remindersAdded)
                        ? (
                            <tr>
                                <td className="text-start">No reminders added.</td>
                                <td></td>
                                <td></td>
                            </tr>
                        )
                        : (
                            remindersAdded.map((reminder, idx) =>
                                <tr key={`reminder-${idx}-row`}>
                                    <td>
                                        <div className='d-flex flex-column gap-1'>
                                            <span style={{ fontWeight: "bold", paddingLeft: "0.5rem" }}>{reminder.salesItemName}</span>
                                            {
                                                reminder.reminded &&
                                                <div className='d-flex flex-column pe-5' style={{ fontSize: "smaller" }}>
                                                    <p className='attributes-title mb-1'>
                                                        Due Date: <span className='attributes-desc'>{stringDateToISODate(reminder.dueDate)}</span>
                                                    </p>
                                                    <p className='attributes-title mb-0'>
                                                        Source: <span className='attributes-desc'>{reminder.reminderSourceName}</span>
                                                    </p>
                                                </div>
                                            }
                                        </div>
                                    </td>
                                    <td className="text-end pe-5">
                                        <Button
                                            variant='outline-primary'
                                            className={reminder.reminded ? 'exam-item-added' : 'exam-item-add'}
                                            onClick={() => onRemind(reminder)}
                                        >
                                            {reminder.reminded ? 'Reminded' : 'Remind'}
                                        </Button>
                                    </td>
                                    <td className='pe-4'>
                                        <div className="d-flex justify-content-end align-items-center gap-2">
                                            <Button variant='outline-primary' style={{width:"5rem"}} onClick={() => removeReminder(reminder.salesItemOptionId)}>
                                                Remove
                                            </Button>
                                        </div>
                                    </td>
                                </tr>
                            )
                        )
                }
            </tbody>
        </Table>
    );
    
});
